import { Api } from "./Api.class";
const endpoint = "stats";
const StatsAPI = new Api(endpoint);
export default StatsAPI;
